import { clamp, isNumber } from 'lodash-es';

import { defaultRatio } from '../constants.js';
import { LegendRatio } from '../types/legend.js';

export const DEFAULT_PIE_LEGEND_RATIO = 80;

export const LEGEND_RATIO_RANGE: { min: number; max: number } = {
  min: 10,
  max: 80,
};

/**
 * Returns the value of the ratio if it is in the range of allowed values (10-80), otherwise it will return the default ratio
 * @param legendRatio -
 */
export const sanitizeLegendRatio = (
  legendRatio: LegendRatio = defaultRatio,
): number =>
  isNumber(legendRatio)
    ? clamp(legendRatio, LEGEND_RATIO_RANGE.min, LEGEND_RATIO_RANGE.max)
    : LEGEND_RATIO_RANGE.max;
